import { ColorGradientPicker } from '@connected/ui/components/color-gradient-picker';
import { Input } from '@connected/ui/components/input';

import type { HandleChange } from './types';

type GradientFieldProps<TValue extends string> = {
    name: string;
    value: TValue;
    className?: string;
    onChange: HandleChange<TValue>;
};

export function GradientField<TValue extends string>({
    name,
    value,
    className,
    onChange,
    ...props
}: GradientFieldProps<TValue>) {
    return (
        <div className="flex flex-col w-full gap-2">
            <ColorGradientPicker
                name={name}
                value={value}
                className={className}
                onChange={e => onChange(e as TValue)}
                {...props}
            />
            <Input
                type="text"
                value={value}
                onChange={e => onChange(e.target.value as TValue)}
            />
        </div>
    );
}
